<template>
  <div>
    <v-card flat v-if="stateFilters.length > 0">
      <v-row class="mx-auto fill-height" no-gutters>
        <v-col cols="12" md="6">
          <v-switch class="mx-2 text-center"
                    :label="$vuetify.lang.t(`$vuetify.map.driverSettings.labels.${detection}`)"
                    :placeholder="getPlaceholder(detection)"
                    :messages="isDebug ? detection : ''"
                    v-model="settings[detection]">
            <v-checkbox v-show="isFineTuning" class="shrink mt-0" slot="prepend"
                        v-model="fineTuningSettings[detection]"></v-checkbox>
          </v-switch>
        </v-col>
      </v-row>
      <v-card-subtitle>
        <v-icon left>{{ filtersIcon }}</v-icon>
        <span
          class="font-weight-bold">{{ $vuetify.lang.t('$vuetify.map.driverSettings.tabContentTitles.filters') }}</span>
      </v-card-subtitle>
      <v-card-text class="px-0 px-md-4">
        <v-row class="mx-auto fill-height" no-gutters>
          <v-col cols="12" :md="entry.hasOwnProperty('mdCols') ? entry.mdCols : 4" class="px-2 mt-n5" align-self="end"
                 v-for="entry in stateFilters" :key="entry.field">
            <v-card-text class="mx-n2 caption" v-if="entry.hasOwnProperty('field')" :class="entry.hasOwnProperty('css') ? entry.css : ''">{{
              $vuetify.lang.t(`$vuetify.map.driverSettings.labels.${entry.hasOwnProperty('label') ? entry.label :
              entry.field}`) }}
            </v-card-text>
            <v-text-field v-if="entry.hasOwnProperty('field')"
                          class="mt-n8"
                          :placeholder="getPlaceholder(entry.field)"
                          type="number" step="1"
                          :rules="timeRules"
                          :messages="isDebug ? entry.field : ''"
                          v-model.number="settings[entry.field]">
              <v-checkbox v-show="isFineTuning" slot="prepend" class="shrink mt-0" dense hide-details
                          v-model="fineTuningSettings[entry.field]"></v-checkbox>

            </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card flat v-if="stateSettings.length > 0">
      <v-card-subtitle>
        <v-icon left>{{ settingsIcon }}</v-icon>
        <span
          class="font-weight-bold">{{ $vuetify.lang.t('$vuetify.map.driverSettings.tabContentTitles.settings') }}</span>
      </v-card-subtitle>
      <v-card-text class="px-0 px-md-4">
        <v-row class="mx-auto fill-height" no-gutters>
          <template v-for="entry in stateSettings">
            <v-col cols="12" :md="entry.hasOwnProperty('mdCols') ? entry.mdCols : 3" class="px-2 mt-n5" align-self="end"
                   :key="entry.field">
              <template v-if="entry.hasOwnProperty('field')">
                <template v-if="entry.hasOwnProperty('type') && entry.type === 'switch'">
                  <v-switch
                    :placeholder="getPlaceholder(entry.field)"
                    :label="$vuetify.lang.t(`$vuetify.map.driverSettings.labels.${entry.hasOwnProperty('label') ? entry.label : entry.field}`)"
                    :messages="isDebug ? entry.field : ''"
                    v-model.number="settings[entry.field]">
                    <v-checkbox v-show="isFineTuning" slot="prepend" class="shrink mt-0" dense hide-details
                                v-model="fineTuningSettings[entry.field]"></v-checkbox>
                  </v-switch>
                </template>
                <template v-else>
                  <v-card-text class="mx-n2 caption" :class="entry.hasOwnProperty('css') ? entry.css : ''">{{
                    $vuetify.lang.t(`$vuetify.map.driverSettings.labels.${entry.hasOwnProperty('label') ? entry.label :
                    entry.field}`) }}
                  </v-card-text>
                  <v-text-field
                    :placeholder="getPlaceholder(entry.field)"
                    class="mt-n8"
                    type="number" :step="entry.hasOwnProperty('step') ? entry.step : 1"
                    :rules="entry.rules"
                    :messages="isDebug ? entry.field : ''"
                    :disabled="entry.hasOwnProperty('canBeDisabled') && entry.canBeDisabled && settings['autoCalibrateEnabled'] === true"
                    v-model.number="settings[entry.field]">
                    <v-checkbox v-show="isFineTuning" slot="prepend" class="shrink mt-0" dense hide-details
                                v-model="fineTuningSettings[entry.field]"></v-checkbox>
                  </v-text-field>
                </template>
              </template>
            </v-col>
          </template>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { timeRules } from '../../../utils/formRules'
import { mdiCogs, mdiFilter } from '@mdi/js'
import driverSettingsMixin from '../../../mixins/driverSettingsMixin'

const filtersIcon = mdiFilter
const settingsIcon = mdiCogs

export default {
  name: 'stateSettings',
  mixins: [driverSettingsMixin],
  props: {
    detection: String,
    stateFilters: {
      type: Array,
      default: () => ([])
    },
    stateSettings: {
      type: Array,
      default: () => ([])
    },
    isDebug: Boolean
  },
  data: () => ({
    filtersIcon: filtersIcon,
    settingsIcon: settingsIcon
  }),
  created () {
    this['timeRules'] = timeRules
  }
}
</script>

<style scoped>

</style>
